import './otp-input.css';
import { FormHelperText, useTheme } from '@mui/material';
import OtpInput from 'react18-input-otp';

const OtpInputMahan = ({ value, onChange, onSubmit, error, disabled }) => {
    const theme = useTheme();

    return (
        <>
            <OtpInput
                className="otp-input"
                value={value}
                onChange={onChange}
                onSubmit={onSubmit}
                isDisabled={disabled}
                isInputNum
                shouldAutoFocus
                containerStyle={{
                    justifyContent: 'space-between',
                    direction: 'ltr',
                }}
                inputStyle={{
                    paddingRight: 15,
                    paddingLeft: 15,
                    paddingTop: 10,
                    paddingBottom: 7,
                    borderRadius: 10,
                    borderWidth: 2,
                    fontSize: 20,
                    fontFamily: 'IRANSans',
                    border: 'solid',
                    outline: 'none',
                    width: '3.5rem',
                    color: theme.palette.text.primary,
                    borderColor: error
                        ? theme.palette.error.main
                        : theme.palette.primary.main,
                    background: 'transparent',
                }}
                focusStyle={{
                    borderColor: theme.palette.primary.main,
                }}
            />

            {error && (
                <FormHelperText sx={{ mt: 1.5 }} error={error !== undefined}>
                    {error}
                </FormHelperText>
            )}
        </>
    );
};

export default OtpInputMahan;
